import axios from 'axios'
import { Toast } from 'antd-mobile'
import { getUser, tagTester, isType } from '@/util'
import { Loading } from '@/components'
// import { fundebugNotifyError } from '@/util/fundebugUse'
import Env from '@/Api/domain'
Env.set()

export default class Server {
  axios(method, url, payload, config = { structured : false}) {
    return new Promise((resolve, reject) => {
      if ( !isType.isObject(payload) && tagTester('Object')(payload) === false  ) payload = {}
      const _config = config
      console.log(getUser())
      const token = getUser().token
      const _option = {
        baseURL: `${Env.getEnv() === 'dev' ? 'http' : 'https' }://${Env.getApiBase()}/webapi`,
        method,
        url,
        timeout: 30000,
        params: null,
        data: null,
        headers: {
          // 'x-client-version': '2.5.5',
          // 虎扑 hpweb_request
          // 'x-client-source': 'hpweb',
          'x-client-lang': `${Env.getLanguage()}`,
          'x-client-platform': 'mobile',
          'Content-Type': 'application/json',
          // 'beartoken': token
          'Authorization': 'Bearer ' + token,
        },
        transformRequest: [function (data) {
          let param
          if ( tagTester('File')(data?.filePath) ) {
            param = new FormData()
            param.append('file', data.filePath)
          } else {
            param = JSON.stringify(data)
          }
          return param
        }],
        ...payload,
      }
      _config.showLoading && Loading.show({
        duration: _config.timeout || 0,
      })
      try {
        axios.request(_option).then(res => {
          _config.showLoading && Loading.close()
          let resolveData = res.data
          if ( _config.structured ) {
            resolveData = res.data.data || res.data || {}
          }
          if ( res.data?.status === 'fail' ) {
            const bussinesError = JSON.stringify(res.data.error)
            if (res.data?.error?.code === 401 ) {
              window.location.href = '/login'
            }
            console.log(res.data?.error?.message)
            if (!_config.hideFailToast) {
              Toast.show({
                content: res.data?.error?.message || '系统异常',
                duration: 2000,
                maskClickable: false
              })
            }
            // fundebugNotifyError(`公共接口${url}报错`, bussinesError)
          }
          resolve(resolveData)
        }, error => {
          if(error.response){
            reject(error.response.data)
          } else {
            reject(error)
          }
          _config.showLoading && Loading.close()
        })
      } catch (error) {
        console.log(error)
      }

    })
  }
}
